import React from 'react';
import { generateClassNameByBehaviorSettings } from '../../../../utils/behaviorSettings';
import { DefaultPictureType } from '../../../../types';
import DefaultPicture from '../../../01_atoms/DefaultPicture';
import { BehaviourSettingsType } from '../../../../utils/behaviorSettings/prop-types';

import styles from './index.module.scss';

type Props = {
  imagePicture: DefaultPictureType;
  title?: string;
  list?: string[];
  color?: 'pink' | 'green';
  behaviorSettings?: BehaviourSettingsType;
  uuid?: string;
};

const BBImpactOverview = ({
  imagePicture,
  title = '',
  list = [],
  color = 'pink',
  behaviorSettings = {},
  uuid = undefined,
}: Props) => {
  const componentName = 'bb-impact-overview';
  // Check if the selected color class exists in the styles object.
  const classes = [
    'bb',
    styles[componentName],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];
  if (styles[componentName + '--color-' + color] !== undefined) {
    classes.push(styles[componentName + '--color-' + color]);
  }
  return (
    <div className={classes.join(' ')} data-component={componentName} data-color={color} id={uuid}>
      {imagePicture && <DefaultPicture loading="lazy" {...imagePicture} />}

      <div className="container">
        <div className={`${styles[componentName + '__overlay']}`}>
          {title && <h2 className={`${styles[componentName + '__title']}`}>{title}</h2>}

          {list.length > 0 && (
            <ul className={`${styles[componentName + '__icon-list']}`}>
              {list.map((item) => (
                <li key={item} className={`${styles[componentName + '__icon-list-item']}`}>
                  <p>{item}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default BBImpactOverview;
